// A merge invoice covers several invoices of one distributor. The printed
// documents show one line per product, so the items of every merged order are
// rolled up by product here.
export const aggregateItems = (mergeInvoice) => {
  if (!mergeInvoice || !mergeInvoice.list) return [];

  const rows = {};

  mergeInvoice.list.forEach((mergeItem) => {
    const order = mergeItem.order;
    if (!order || !order.list) return;

    order.list.forEach((item) => {
      const key = item.product_id;

      if (!rows[key]) {
        rows[key] = {
          product_id: item.product_id,
          product: item.product,
          rate: Number(item.rate) || 0,
          // VAT rates are product constants copied onto the order line, so they
          // survive the roll-up unchanged.
          sdv_inv: item.sdv_inv,
          sd_inv: item.sd_inv,
          vat_inv: item.vat_inv,
          ordrPackQty: 0,
          qty: 0,
          toQty: 0,
          invQty: 0,
          price: 0,
        };
      }

      rows[key].ordrPackQty += Number(item.ordrPackQty) || 0;
      rows[key].qty += Number(item.qty) || 0;
      rows[key].toQty += Number(item.toQty) || 0;
      rows[key].invQty += Number(item.invQty) || 0;
      rows[key].price += Number(item.price) || 0;
    });
  });

  return Object.values(rows);
};

export const mergedOrderNos = (mergeInvoice) => {
  if (!mergeInvoice || !mergeInvoice.list) return "";

  return mergeInvoice.list
    .map((mergeItem) => (mergeItem.order ? mergeItem.order.receipt_no : null))
    .filter(Boolean)
    .join(", ");
};

export const grandTotal = (items) => items.reduce((total, item) => total + (Number(item.price) || 0), 0);

export const getCartonAndPieces = (totalQty, crtnSize) => {
  const size = Number(crtnSize) || 0;
  if (size < 1) return `${totalQty} pcs`;

  const crtns = Math.floor(totalQty / size);
  const pcs = totalQty % size;
  if (crtns < 1) return `${pcs} pcs`;
  return `${crtns} Crtn ${pcs} pcs`;
};
